import * as tracking from '../util/tracking';

const hitsWithNoQuery = 4;
const hitsWithQuery = 3;

let resultCache;
let queryCache;

export function createCategoriesSearchPlugin({ searchClient }) {
  return {
    getSources() {
      return [
        {
          sourceId: 'categoriesSearchPlugin',
          async getItems({ query }) {
            // Check cache
            if (resultCache && query === queryCache) return resultCache;

            // Request data
            const result = await searchClient
              .collections(window.cece.typesense.groupsCollectionName)
              .documents()
              .search({
                q: query || '*',
                query_by: 'display_name',
                sort_by: 'preview_order:asc',
                filter_by: `language:${window.cece.language}${
                  window.cece.searchSection
                    ? ' && section_slug:' +
                      window.cece.searchSection.toLowerCase()
                    : ''
                }`,
                limit_hits: query ? hitsWithQuery : hitsWithNoQuery,
                per_page: query ? hitsWithQuery : hitsWithNoQuery,
              });

            // Cache and return
            queryCache = query;
            resultCache = result.hits.map(h => h.document);
            return resultCache;
          },
          getItemUrl({ item }) {
            return item.url;
          },
          templates: {
            header() {
              return window.i18n.header.searchCategoriesHeader;
            },
            item({ item, createElement }) {
              return createElement(
                'div',
                { class: 'catalog-search-item' },
                createElement(
                  'a',
                  {
                    class: 'content',
                    href: item.url,
                    onClick(event) {
                      event.preventDefault();
                      tracking.trackEvent(
                        'CatalogSearch',
                        'ManualSearch',
                        `category:${item.section_slug}:${item.display_name}`
                      );
                      setTimeout(function () {
                        window.location.href = item.url;
                      }, 50);
                    },
                  },
                  item.display_name,
                  // components.Highlight({
                  //   hit: item,
                  //   attribute: 'display_name',
                  //   tagName: 'mark',
                  // }),
                  createElement(
                    'span',
                    { class: 'dimmed' },
                    ' - ' + item.section_name
                  )
                )
              );
            },
          },
        },
      ];
    },
  };
}
